import React from "react";
import { Link } from "react-router-dom";
import "../assets/css/styles.css";
import farm_logo from "../assets/images/logo2.png";
import { Discord, Instagram, LinkedIn } from "../components/Icons";

const QUICK_LINKS = [
  { label: "How it works", href: "/#how-it-works" },
  { label: "About Us", href: "/#about" },
  { label: "Share sizes", href: "/#shares" },
  { label: "Services", href: "/#services" },
  { label: "Delivery", href: "/#delivery" },
  { label: "FAQ", href: "/#faq" },
  { label: "Contact", href: "/#contact" },
];

const SHOP_LINKS = [
  { label: "Order Now", to: "/order-now" },
  { label: "Track Order", to: "/track-order" },
  { label: "Terms & Conditions", to: "/terms" },
  { label: "Privacy Policy", to: "/privacy-policy" },
];

const SOCIALS = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/farmerboaz?igsh=MXNrdGMwbjdqcW5lNQ==",
    icon: <Instagram />,
  },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/farmer-boaz", icon: <LinkedIn /> },
  { label: "Discord", href: "https://discord.gg/X47Vt45XWh", icon: <Discord /> },
];

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="brand" aria-label="Farmer Boaz — home">
              <span className="brand-mark">
                <img src={farm_logo} alt="" />
              </span>
              <span className="brand-text">
                <span className="brand-name">Farmer Boaz</span>
                <span className="brand-tag">Farm to table</span>
              </span>
            </Link>
            <p>
              Farmer Boaz connects local farmers with our community, making it easy to access
              fresh, high-quality produce and meat straight from the source. Every order helps
              build a stronger, more sustainable community — because good food brings people
              together.
            </p>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Explore</h4>
            <ul>
              {QUICK_LINKS.map((link) => (
                <li key={link.label}>
                  <a className="footer-link" href={link.href}>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Shop & support</h4>
            <ul>
              {SHOP_LINKS.map((link) => (
                <li key={link.label}>
                  <Link className="footer-link" to={link.to}>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>

            <h4 className="footer-heading" style={{ marginTop: "1.75rem" }}>
              Follow us
            </h4>
            <div className="social-row">
              {SOCIALS.map((social) => (
                <a
                  key={social.label}
                  className="social-icon"
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  title={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Farmer Boaz by Codelithic Labs. All rights reserved.</p>
          <p>
            Designed with care by{" "}
            <a href="https://codelithiclabs.com" target="_blank" rel="noopener noreferrer">
              Codelithic Labs Inc.
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
